import { toCalendarDateUTC } from '@/utils/intl/dateTimeFormatters'
import type { QueryClient } from '@tanstack/react-query'
import type { SupplyOptionsRequest } from './requests'

export function removeOrderFromCache(options: {
  queryClient: QueryClient
  endpointKey: string
  orderId: Gravitate.Order['id']
}) {
  const { queryClient, endpointKey, orderId } = options
  queryClient.setQueriesData<{ rows: Gravitate.Order[] }>({ queryKey: [endpointKey] }, (oldData) => {
    if (!oldData) return oldData
    return {
      ...oldData,
      rows: oldData.rows.filter((o) => o.id !== orderId),
    }
  })
}

export function updateOrderInCache(options: {
  queryClient: QueryClient
  endpointKey: string
  updatedOrder: Gravitate.Order
}) {
  const { queryClient, endpointKey, updatedOrder } = options
  queryClient.setQueriesData<{ rows: Gravitate.Order[] }>({ queryKey: [endpointKey] }, (oldData) => {
    if (!oldData) return oldData
    return {
      ...oldData,
      rows: oldData.rows.map((order) => {
        if (updatedOrder.id === order.id) {
          return updatedOrder
        }
        return order
      }),
    }
  })
}

export const validateSupplyOptionsPayload = (payload: SupplyOptionsRequest) => {
  const hasPayload = payload?.pockets && !payload?.pockets?.includes(null) && payload?.destinations?.length > 0
  if (!hasPayload) return false

  const noNA =
    payload.pockets.filter((pocket) => pocket?.targets?.find((item) => item.location_name === 'N/A')).length === 0
  if (!noNA) return false
  const locationNames = payload.pockets?.flatMap((pocket) => pocket?.targets?.map((target) => target?.location_name))
  const found = locationNames?.filter((name) => !payload.destinations.includes(name))
  return !found.length
}

export function getFilterWithCalendarShiftDate<T extends object>(filter: T): T {
  const shiftDate = (filter as { 'Shift Date'?: unknown } | undefined)?.['Shift Date']
  if (!shiftDate) return filter
  return { ...filter, 'Shift Date': toCalendarDateUTC(shiftDate as string) }
}
